export default __webpack_public_path__ + "static/media/603.7885b18d.png";